import { styled } from "@mui/material/styles";

const Box = styled('div')(({ theme }) => ({
  height: 42,
  width: 10
}));

export { Box };
  